import { graphql } from 'gql';

export const uerWorkOrderChangeOtherCostSelectionListGql = graphql(`
    query uerWorkOrderChangeOtherCostSelectonList(
        $workOrderChangeId: Long!
        $constructionTypeId: Int!
        $where: WorkOrderChangeOtherCostItemFilterInput
    ) {
        uerWorkOrderChangeOtherCostSelectonList(
            workOrderChangeId: $workOrderChangeId
            constructionTypeId: $constructionTypeId
            where: $where
        ) {
            otherCost {
                contractOtherCostId
                catalogOtherCostTypeId
                catalogOtherCostType {
                    canDelete
                    isSystem
                    id
                    uniqueId
                    name
                }
                name
                calculatingType
                calculatingTypeValue
                chapter
                section
                status
            }
            workOrderChangeObjects {
                rootObjectId {
                    workOrderObjectId
                    workOrderChangeObjectId
                }
                hasActualCost
                isActKC2Cost
                contractObjectId
                name
                rationale
                isIncluded
                canAddOther
                canRemoveOther
            }
            seasonLimits {
                workOrderChangeSeasonId
                workOrderSeasonId
                year
                includedCost
                isIncluded
                planCost
                actualCost
                remainderCost
                deviation
            }
            hasSeasonLimits
            sortPart
        }
    }
`);

export const uerUpdateWorkOrderChangeOtherCostItemsGql = graphql(`
    mutation uerUpdateWorkOrderChangeOtherCostItems(
        $workOrderChangeId: Long!
        $constructionTypeId: Int!
        $otherPriceInputs: [UpdateWorkOrderChangeOtherPriceItemInput!]!
    ) {
        uerUpdateWorkOrderChangeOtherCostItems(
            workOrderChangeId: $workOrderChangeId
            constructionTypeId: $constructionTypeId
            otherPriceInputs: $otherPriceInputs
        ) {
            data
            result
            message
            buttonText
            hasValidation
            hideValidation
            validation {
                property
                message
            }
        }
    }
`);
